import { WebSocketReceiveMessage } from './web-socket-receive-message';
import { BudBotConversation } from '../../../budbot/bud-bot-conversation';

export class WebSocketBudBotConversationResponse extends WebSocketReceiveMessage {
  override payload: BudBotConversation;

  override onDeserialize() {
    super.onDeserialize();
    this.payload = window?.injector?.Deserialize.instanceOf(BudBotConversation, this.payload);
  }
}
